module.exports = __webpack_public_path__ + "media/images/menu/conjunctions-63c6bed22bd3b6b5ebdc58d4fd40a8f7.jpg";